import { Pipe, PipeTransform } from '@angular/core';
import { Position, EsimModel } from '../../../models/position.model';
import { TranslateService } from '@ngx-translate/core';
/** SimNumberPipe */
@Pipe({
    standalone: true,
    name: 'simNumberPipe',
})
export class SimNumberPipe implements PipeTransform {
    /**
     *
     * @param ts
     */
    public constructor (private ts: TranslateService) { }
/** transform */
    public transform (hardwareSimPositions: {
        /** simOnlyObj */
        simOnlyObj?: Position,
        /** HardwareObj */
        HardwareObj?: Position,
        /** esimObj */
        esimObj?: EsimModel,
    } | any, args?: any): string {

        const simNumberLabel = this.ts.instant('common.simNumberLabel.std-headline');
        const msisdn = this.ts.instant('common.msisdn.std-headline');

        if (hardwareSimPositions) {

            if (hardwareSimPositions.simOnlyObj && hardwareSimPositions.simOnlyObj.simNumber) {

                return simNumberLabel + ' ' + hardwareSimPositions.simOnlyObj.simNumber;
            } else if (hardwareSimPositions.esimObj && hardwareSimPositions.esimObj.serialNumber) {

                return simNumberLabel + ' ' + hardwareSimPositions.esimObj.serialNumber;
            } else if (hardwareSimPositions.HardwareObj && hardwareSimPositions.HardwareObj.simNumber) {

                return simNumberLabel + ' ' + hardwareSimPositions.HardwareObj.simNumber;
            } else if (hardwareSimPositions.simOnlyObj && hardwareSimPositions.simOnlyObj.msisdn) {

                return msisdn + ' ' + hardwareSimPositions.simOnlyObj.msisdn;
            } else if (hardwareSimPositions.HardwareObj && hardwareSimPositions.HardwareObj.msisdn) {

                return msisdn + ' ' + hardwareSimPositions.HardwareObj.msisdn;
            }
        }

        return '';
    }

}
